import { useState } from 'react';
import { Xmark, Lock } from '@gravity-ui/icons';
import { Button, Icon, Modal, Sheet } from '@gravity-ui/uikit';

import { useUnblockUserMutation } from 'store/api/private/user-api/admin-api';

import { CANCEL, UNBLOCK, UNBLOCK_ACC, UNBLOCK_QUESTION } from '../../constants';
import { toast } from 'react-toastify';
import styles from '../modals/styles.module.scss';

interface Person {
	id: number;
	email: string;
	role: string;
	firstName: string;
	middleName: string;
	lastName: string;
	establishment: {
		id?: number;
		name?: string | null;
	} | null;
	imageUrl: string;
	region: {
		code?: number;
		fullname: string;
		guid?: string;
		name?: string;
	};
	specialty: string;
	createdDate: string;
	active: boolean;
}

interface AccountUnblockSheetProps {
	account: Person;
	onAdd: () => void;
	updateAccountStatus: (updatedAccount: Person) => void;
}

export const AccountUnblockSheet = ({ account, onAdd, updateAccountStatus }: AccountUnblockSheetProps) => {
	const [open, setOpen] = useState(false);

	const [unblockAccount] = useUnblockUserMutation();

	const onSubmit = () => {
		unblockAccount({ email: account.email });
		setOpen(false);
		updateAccountStatus({ ...account, active: false });
		onAdd();
		toast.success('Аккаунт специалиста успешно разблокирован');
	};

	return (
		<>
			<Button view="flat" size="l" onClick={() => setOpen(true)}>
				<Icon data={Lock} size={16} />
				Разблокировать
			</Button>

			<Sheet visible={open} onClose={() => setOpen(false)} title={UNBLOCK_ACC}>
				<div className={styles.sheet__close}>
					<Button onClick={() => setOpen(false)} view="flat">
						<Icon data={Xmark} size={16} />
					</Button>
				</div>

				<div className={styles.modal__question}>{UNBLOCK_QUESTION}</div>

				<div className={styles.modal__btns}>
					<Button size="xl" view="flat-secondary" onClick={() => setOpen(false)}>
						{CANCEL}
					</Button>
					<Button
						size="xl"
						onClick={() => {
							onSubmit();
							setOpen(false);
						}}
						className={styles.modal__btns__unblock}
					>
						{UNBLOCK}
					</Button>
				</div>
			</Sheet>
		</>
	);
};
